import styled from 'styled-components';
import {breakPoint} from './var';

export const CardStyles = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  border-radius: 2.5rem;
  overflow: hidden;
  border: .6rem white solid;
  color: white;
  .img {
    text-align: center;
  }
  .card-body {
    padding: 2rem;
  }
  hgroup {
    flex: 1 1 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      font-size: 2.8rem;
      border-top: 2px solid white;
      border-bottom: 2px solid white;
      padding: .4rem 2rem;
    }

    h3 {
      font-size: 2.1rem;
      margin-bottom: 1rem;
    }
  }
  
  @media (max-width: ${breakPoint.max}) {
    .card-body {
      padding: 1.5rem;
    }
    p {
      margin-top: 1rem;
    }
    hgroup {
      h2 {
        font-size: 1.8rem;
        padding: .4rem 1.2rem;
      }

      h3 {
        font-size: 1.3rem;
        margin-bottom: .8rem;
      }
    }
  }
`;

